import { render, staticRenderFns } from "./RegisterPlayer.vue?vue&type=template&id=ab7bcb48&scoped=true"
import script from "./RegisterPlayer.vue?vue&type=script&lang=js"
export * from "./RegisterPlayer.vue?vue&type=script&lang=js"
import style0 from "./RegisterPlayer.vue?vue&type=style&index=0&id=ab7bcb48&prod&lang=css"
import style1 from "./RegisterPlayer.vue?vue&type=style&index=1&id=ab7bcb48&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7bcb48",
  null
  
)

export default component.exports